<template xmlns="http://www.w3.org/1999/html">
  <div class="shengsheng-page">
    <!-- 顶部整宽的酒图片 -->
    <img class="jiu-img" src="/static/images/shengsheng/jiu.png" alt="酒背景">

    <!-- 中间位置浮动的yinying.png -->
    <img class="yinying-img" src="/static/images/shengsheng/yinying.png" alt="阴影">

    <!-- yinying.png中间位置的scan.png -->
    <img class="scan-img" src="/static/images/shengsheng/scan.png" alt="扫描" @click="scan">

    <!-- scan.png下面的scantip.png -->
    <img class="scantip-img" src="/static/images/shengsheng/scantip.png" alt="扫描提示">
  </div>
</template>

<style scoped>
.shengsheng-page {
  position: relative;
  width: 100vw;
  min-height: 100vh;
  /* 用 bg.png 做全屏背景 */
  background: url("/static/images/shengsheng/bg.png") no-repeat center top;
  background-size: cover;
  overflow: hidden;
}

.jiu-img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  display: block;
}

.yinying-img {
  position: fixed;
  bottom: 20vh;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  height: 52vh;
  z-index: 10;
}

.scan-img {
  position: fixed;
  bottom: 40vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
  max-width: 45vw;
  max-height: 45vh;
  cursor: pointer;
}

.scantip-img {
  position: fixed;
  bottom: 35vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11;
  max-width: 28vw;
  max-height: 15vh;
}
</style>

<script>
import { getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      eno: '138666725759', // 固定企业号
      antiCode: ''
    };
  },
  methods: {
    scan() {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          var scanResult = res.resultStr
          var scanQRCode = scanResult
          if (scanResult.startsWith('http')) {
            let parts = scanResult.split('/');
            scanQRCode = parts.length > 0 ? parts[parts.length - 1] : ''
            scanQRCode = scanQRCode.substring(0, 16)
          }
          this.antiCode = scanQRCode
          this.$router.push({
            path: '/ssheng/result',
            query: {
              eno: this.eno,
              c: this.antiCode
            }
          });
        }
      });
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx099133a5b38815d5").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted() {
    this.getWxJs();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ShengSheng/Index.vue